/**
 * Shared checkout form gate used by B2C Payment and B2B PackagePayment.
 * Ignores empty/undefined error keys left by controlled form clearing.
 */
export const isPaymentFormValid = ({
  card,
  address,
  cardErrors = {},
  addressErrors = {},
  termsAccepted,
  isSubmitting = false,
}) => {
  const cardFilled = Boolean(
    card?.number?.trim() &&
    card?.name?.trim() &&
    card?.expiry?.trim() &&
    card?.cvv?.trim()
  );

  const addressFilled = Boolean(
    address?.zip_code?.trim() &&
    address?.street?.trim() &&
    address?.number?.trim() &&
    address?.neighborhood?.trim() &&
    address?.city?.trim() &&
    address?.state?.trim()
  );

  const hasErrors =
    Object.values(cardErrors).some(Boolean) ||
    Object.values(addressErrors).some(Boolean);

  return cardFilled && addressFilled && !hasErrors && Boolean(termsAccepted) && !isSubmitting;
};

export default isPaymentFormValid;
